module.exports = __webpack_public_path__ + "img/serviceDetail1.ae58820c.png";